import Text from 'components/Text/Text';
import { IDishAllSubCategory } from 'types';
import React, { useMemo } from 'react';
import style from './SubcategoriesList.module.scss';

interface ISubcategoriesList {
	initialSubCategories: IDishAllSubCategory[];
}

const SubcategoriesList: React.FC<ISubcategoriesList> = ({ initialSubCategories }) => {
	const subCategoriesList = useMemo(() => {
		return initialSubCategories.map((el) => (
			<div className={style.item} key={el.id}>
				<div className={style.dot} />
				<Text translationKey={el.subCategoryName} withTooltip={true} />
			</div>
		));
	}, [initialSubCategories]);

	return (
		<div data-test="SubcategoriesList">
			<Text translationNameSpace="form" translationKey="subcategoryHeading" theme="neutralLight" size="xs" />
			<div className={style.listOfItems}>{initialSubCategories.length ? subCategoriesList : '-'}</div>
		</div>
	);
};

export default React.memo(SubcategoriesList);
